import {
  Dropdown,
  Menu,
  message,
} from 'antd';
import React from 'react';
import { getUserId } from '@/infrastructure/auth';
import { getProductId } from '@/infrastructure/product-info';
import { modifyIssueStatusBatch } from '@/presentation/components/issue-status-batch/api';
import {
  Zone,
  ISSUE_STATUS_OPTION,
  FIELD_ALL,
} from '@/proto/field';

type IProps<T> = {
  type: Zone;
  rows: T[];
  onSubmit: () => void;
  options?: { label: string, value: string }[];
};

export const IssueStatusBatch = <T extends Record<string, any>>(props: IProps<T>) => {
  const { type, rows, onSubmit, options } = props;

  const onClick = async (status: string) => {
    const succ = await modifyIssueStatusBatch({
      type,
      issueKeys: rows.map(row => row.feature),
      status,
      productId: getProductId(),
      operator: getUserId(),
    });

    if (succ) {
      message.success('批量更改问题状态成功');
      onSubmit();
    } else {
      message.error('批量更改问题状态失败');
    }
  };

  const statusOptions = options || ISSUE_STATUS_OPTION.filter(item => item.value !== FIELD_ALL);
  const disabled = rows.length === 0;

  const menu = () => <Menu onClick={({ key }) => onClick(key)}>
    {statusOptions.map(item => <Menu.Item key={item.value}>
      {item.label}
    </Menu.Item>)}
  </Menu>;

  return <Dropdown overlay={menu} trigger={['click']} disabled={disabled} >
    <div>批量标记处理状态</div>
  </Dropdown>;
};
